import { render, staticRenderFns } from "./ReportDesktopGroupedMatrix.vue?vue&type=template&id=0ef4b3b6"
import script from "./ReportDesktopGroupedMatrix.vue?vue&type=script&lang=js"
export * from "./ReportDesktopGroupedMatrix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports